import { Avatar, Button, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { SmallCheckmark, View } from 'Images';

interface ISelectedInvoiceFile {
  file: File | null;
  watchFile: (fileData: File | null, fileName: string) => void;
}

export const SelectedInvoiceFile = ({
  file,
  watchFile,
}: ISelectedInvoiceFile) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Reimbursements).form;
  const isDesktop = useIsDesktop();

  return (
    <Stack
      sx={{
        bgcolor: '#F6F8FE',
        p: isDesktop ? '32px' : '20px 16px 22px',
        gap: '16px',
        borderRadius: '16px',
        mt: isDesktop ? undefined : '16px',
      }}
    >
      <Typography variant='body2'>{dictionary.selectedInvoice}</Typography>
      <Stack
        sx={{
          bgcolor: 'white',
          borderRadius: '8px',
          gap: '8px',
          p: '8px 2px',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <Avatar
          alt=''
          src={SmallCheckmark}
          sx={{ width: '32px', height: '32px' }}
        />
        <Typography variant='body1'>{file?.name}</Typography>
      </Stack>
      <Button
        sx={{
          alignSelf: 'flex-end',
          color: 'black',
          gap: '4px',
        }}
        onClick={() => watchFile(file, file?.name || '')}
      >
        <Avatar alt='' src={View} sx={{ width: '24px', height: '24px' }} />
        <Typography variant='body5'>{dictionary.view}</Typography>
      </Button>
    </Stack>
  );
};
